
import Vue from "vue";
import DataListSourceComponent from "@/components/source/DataListSourceComponent.vue";
import DataListFamilyComponent from "@/components/family/DataListFamilyComponent.vue";
import DataListMoleculeComponent from "@/components/molecule/DataListMoleculeComponent.vue";
import DataListSynergyComponent from "@/components/synergy/DataListSynergyComponent.vue";

export default Vue.extend({
  name: "DataListView",

  components: {
    DataListSourceComponent,
    DataListFamilyComponent,
    DataListMoleculeComponent,
    DataListSynergyComponent,
  },
  props: { mode: String },
});
